import { DEFAULT_BRANCH_INDEX } from 'automation-ui-action-features/records/recordsUtils';
export function getEdgeIdForAction(actionId, branchIndex = DEFAULT_BRANCH_INDEX) {
  return `${actionId}-edge-${branchIndex + 2}`;
}